import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';
import { DEFAULT_PATH } from '../navigation.constants';
import { queryParamsKeys } from '../query-param-key.contants';

export const loginGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const loginError = route.queryParamMap.get(queryParamsKeys.ERROR);
  const returnPath = route.queryParamMap.get(queryParamsKeys.REDIRECT_URL_AFTER_LOGIN_SUCCESS);

  if (loginError || !auth.isAuthenticated()) {
    return true;
  }

  if (returnPath) {
    return router.navigateByUrl(returnPath);
  }

  return router.parseUrl(DEFAULT_PATH);
};
